<template>
    <div class="book-flats-counter-container">
        <!-- <div class="flats-counter book-flats-counter">
            <div class="num" v-html="getWrap_ofSTR(numberCountBook)"></div>
            <div class="title">
                <h6>
                    <span v-if="globalLang == ''">КВАРТИР</span>
                    <span v-if="globalLang == 'kz/'">ПӘТЕРЛЕР</span>
                    <span v-if="globalLang == 'en/'">FLATS</span>
                </h6>
                <h5>{{flatsPage.flats_cards_info.book_counter_title}} </h5>
            </div>
        </div> -->
        <div class="flats-counter by-flats-counter">
            <div class="num" v-html="getWrap_ofSTR(numberCountBy)"></div>
            <div class="title">
                <h6>
                    <span v-if="globalLang == ''">КВАРТИР</span>
                    <span v-if="globalLang == 'kz/'">ПӘТЕРЛЕР</span>
                    <span v-if="globalLang == 'en/'">FLATS</span>
                </h6>
                <h5>{{flatsPage.flats_cards_info.book_by_title}}</h5>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-crm-book-counter',
        props: ['mobileView'],
        components: {
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                routerName: this.$router.history.current.name,
                numberCountBook: 177,
                numberCountBy: 77,
            }
        },
        computed: mapGetters({
            isMobileChecker: 'loadIsMobileChecker',
            flatsPage: 'loadFlatsPage',
        }),
        methods: {
            getWrap_ofSTR(str) {
                return str.toString().split('').map(char => /\d/.test(char) ? `<span>${char}</span>` : char).join('');
            },
            // initNumberCounter() {
            //     var date = new Date();
            //     var time = date.getHours();
            //     var bookCount = 5;
            //     var bookCount_oneHour = 5 / 24; // 0.2 с копейками в час
            //     var number;
            //     function utcdate(d){
            //         return new Date(d.getFullYear(),d.getMonth(),d.getDate());
            //     }
            //     function days(a,b){
            //         return Math.floor((utcdate(b)-utcdate(a))/86400000);
            //     }
            //     const count=174, date0=new Date(2023,5,7); // 18 November 2022
            //     number = count + 5*days(date0, new Date());
            //     mber = number - bookCount;
            //     number = number + bookCount_oneHour*time;
            //     this.numberCountBook = parseInt(number);
            // },
            initNumberCounter() {
                function incrementEveryThreeDays(baseNumber, incrementNumber) {
                    var currentDate = new Date();
                    var startDate = new Date('2023-06-05');  // Начальная дата, от которой будет отсчитываться время
                    var daysPassed = Math.floor((currentDate - startDate) / (1000 * 60 * 60 * 24));
                    var incrementCount = Math.floor(daysPassed / 3);  // Количество увеличений счетчика
                    var result = baseNumber + incrementCount * incrementNumber;
                    return result;
                }
                // Пример использования
                var baseNumberBy = 77;  // Исходное число
                var incrementNumberBy = 1;  // Число, которое будет прибавляться каждые 3 дня

                var baseNumberBook = 177;  // Исходное число
                var incrementNumberBook = 3;  // Число, которое будет прибавляться каждые 3 дня

                var counterValueBy = incrementEveryThreeDays(baseNumberBy, incrementNumberBy);
                var counterValueBook = incrementEveryThreeDays(baseNumberBook, incrementNumberBook);

                this.numberCountBy = counterValueBy;
                this.numberCountBook = counterValueBook;
                // console.log(counterValueBy);
            },  
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.initNumberCounter();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-book-counter.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-filter-respond.scss';
</style>